import { Controller } from "@hotwired/stimulus";

const ENABLED_BORDER_CLASS = "border-primary";
const DISABLED_BORDER_CLASS = "border-input";

const ENABLED_TEXT_CLASS = "text-primary";
const DISABLED_TEXT_CLASS = "text-muted-foreground";

const MAX_POINT_DIGITS = 3;

export default class extends Controller {
  static targets = ["amount", "input", "toggleInput"];

  connect() {
    this.toggle();
  }

  toggle() {
    const enabled = this.toggleInputTarget.value === "true";

    this.element.classList.toggle(ENABLED_BORDER_CLASS, enabled);
    this.element.classList.toggle(DISABLED_BORDER_CLASS, !enabled);

    this.inputTarget.classList.toggle(ENABLED_BORDER_CLASS, enabled);
    this.inputTarget.classList.toggle(DISABLED_BORDER_CLASS, !enabled);
    this.inputTarget.disabled = !enabled;

    this.amountTarget.classList.toggle(ENABLED_TEXT_CLASS, enabled);
    this.amountTarget.classList.toggle(DISABLED_TEXT_CLASS, !enabled);
  }

  input() {
    // Numbers only, up to 3 digits. We don't use a number input type to avoid
    // the arrows that the browser renders.
    this.inputTarget.value = this.inputTarget.value
      .replace(/\D/g, "")
      .substring(0, MAX_POINT_DIGITS);
  }
}
